import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CART_TIP_PICKER_BLOCK_DATA_SOURCE,
  CartTipPickerBlockDataSource,
} from './cart-tip-picker-block-view-model';
import { CartTipPickerBlockPreviewDataSource } from './cart-tip-picker-block-preview-data-source';
import { CartTipPickerBlockStoreDataSource } from './cart-tip-picker-block-store-data-source';

export function provideCartTipPickerBlockDataSource(): Provider[] {
  return [
    CartTipPickerBlockStoreDataSource,
    CartTipPickerBlockPreviewDataSource,
    {
      provide: CART_TIP_PICKER_BLOCK_DATA_SOURCE,
      useFactory: (): CartTipPickerBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CartTipPickerBlockPreviewDataSource)
          : inject(CartTipPickerBlockStoreDataSource);
      },
    },
  ];
}
